import * as React from 'react';
import { Avatar } from 'Common/components/Atoms/Avatar';
import { Col, Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Link } from 'Common/components/Atoms/Link';
import { Text } from 'Common/components/Atoms/Text';
import {
  faGithub,
  faFacebook,
  faTwitter,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { useTheme } from '@mui/material/styles';
import { Links } from '../../../../constants/Links';
import { LANDING } from 'DisplayText/ReviewerOnboarding';

export const Footer = () => {
  const theme = useTheme();
  return (
    <Col
      alignItems="center"
      backgroundColor={theme.palette.primary.dark}
      color={theme.palette.grey[300]}
      py={2}
    >
      <Link href={Links.MARKETING} target="_blank">
        <Avatar
          color={theme.palette.primary.main}
          size={'44px'}
          src="https://www.pullrequest.com/images/logos/pullrequest-circle-logo.svg"
        />
      </Link>
      <Flex>
        <Link m={1} color="inherit" href={Links.FACEBOOK} target="_blank">
          <FontIcon icon={faFacebook} size="lg" />
        </Link>
        <Link m={1} color="inherit" href={Links.GITHUB} target="_blank">
          <FontIcon icon={faGithub} size="lg" />
        </Link>
        <Link m={1} color="inherit" href={Links.TWITTER} target="_blank">
          <FontIcon icon={faTwitter} size="lg" />
        </Link>
        <Link m={1} color="inherit" href={Links.LINKEDIN} target="_blank">
          <FontIcon icon={faLinkedinIn} size="lg" />
        </Link>
      </Flex>
      <Flex fontSize={10} mb={1}>
        <Link color="inherit" px={0.5} href={Links.TERMS} target="_blank">
          {LANDING.TERMS}
        </Link>
        <div>|</div>
        <Link
          color="inherit"
          px={0.5}
          href={Links.PRIVACY_POLICY}
          target="_blank"
        >
          {LANDING.PRIVACY}
        </Link>
        <div>|</div>
        <Link
          color="inherit"
          px={0.5}
          href={Links.SECURITY_POLICY}
          target="_blank"
        >
          {LANDING.SECURITY}
        </Link>
      </Flex>
      <Text color="inherit" fontSize={10}>
        {LANDING.COPYRIGHT}
      </Text>
    </Col>
  );
};
